import React, {memo, useRef, useState} from "react";
import {useDispatch} from "react-redux";
import PropTypes from "prop-types";

//helpers:
import {getImageFromFilesbyKey} from "../../../../../_metronic/_helpers";

//components:
import {makeStyles, Table, TableBody, TableCell, TableFooter, TableHead, TableRow} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import {CustomTooltip, PaginationTable, ConfirmDelete, SuccessDelete, FailedDelete} from "../../../../widgets";

import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import PlayCircleFilledWhiteOutlinedIcon from "@material-ui/icons/PlayCircleFilledWhiteOutlined";
//redux:
import {deleteMediaItem, editMediaItem} from "../../../../redux/Settings/homePageSlice";
import {VisibilityOff} from "@material-ui/icons";

//styles:
const tracksListStyles = makeStyles(() => ({
    root: {
        width: "100%",
    },
    table: {
        minWidth: 500,
    },
}));

const TopBannerTable = ({t, videos}) => {
    const classes = tracksListStyles();

    //redux:
    //actions:
    const dispatch = useDispatch();

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [showEditOrder, setShowEditOrder] = useState(false);
    const [videoId, setVideoId] = useState("");

    //modals:
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showDeletedModal, setShowDeletedModal] = useState(false);
    const [showDeletedFailedModal, setShowDeletedFailedModal] = useState(false);

    //refs:
    const tableRef = useRef(null);

    const headRows = [
        {
            id: "type_id",
            align: "left",
            disablePadding: false,
            label: t("TABLE.HEADER.TYPE"),
        },
        {
            id: "name",
            align: "left",
            disablePadding: false,
            label: t("ADMINPANEL.HOMEPAGE.BANNER.TABLE.HEADER.VIDEO"),
        },
        {
            id: "order",
            align: "center",
            disablePadding: false,
            label: t("TABLE.HEADER.ORDER"),
        },
        {
            id: "actions",
            align: "center",
            disablePadding: false,
            label: t("TABLE.HEADER.ACTIONS"),
        },
    ];

    const desc = (a, b, orderBy) => {
        const aLowerCase = a[orderBy] || 0;
        const bLowerCase = b[orderBy] || 0;

        if (bLowerCase < aLowerCase) {
            return -1;
        }
        if (bLowerCase > aLowerCase) {
            return 1;
        }
        return 0;
    };

    const stableSort = (array, cmp) => {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = cmp(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        const stableSorted = stabilizedThis.map(el => el[0]);
        return stableSorted;
    };

    const getSorting = (order, orderBy) => {
        return order === "desc" ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
    };

    const deleteIt = () => {
        dispatch(deleteMediaItem(videoId));
        setVideoId("");
    };

    const handleEditVideo = (value, key, id) => {
        dispatch(editMediaItem({key, value, id}));

        setShowEditOrder("");
    };

    return (
        <div className={`${classes.root}`}>
            <div
                className={`custom-scroll-area horizontal-scroll`}
                // onWheel={onWheel}
                ref={tableRef}
            >
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            {headRows.map(row => (
                                <TableCell
                                    className="text-muted font-size-1rem"
                                    key={row.id}
                                    align={row.align}
                                    padding={row.disablePadding ? "none" : "default"}
                                >
                                    {row.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {videos &&
                            stableSort(videos, getSorting("asc", "order"))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(
                                    ({
                                        order = 0,
                                        video: {
                                            id = 0,
                                            visible = 1,
                                            files = [],
                                            title = "",
                                            type_id = 0,
                                            thumbnail = getImageFromFilesbyKey(files, id, "imgSquare", type_id),
                                        },
                                    }) => (
                                        <TableRow key={id}>
                                            <TableCell align="left" className="text-muted mb-0">
                                                {type_id === 1 ? (
                                                    <PlayCircleFilledWhiteOutlinedIcon className="w-30px h-30px" />
                                                ) : (
                                                    <DescriptionOutlinedIcon className="w-30px h-30px" />
                                                )}
                                            </TableCell>
                                            <TableCell align="left" component="th" scope="row">
                                                <div className="d-flex align-items-center">
                                                    <div className="d-flex w-50px h-50px">
                                                        <span
                                                            className="bg_image_cover rounded h-100 w-100"
                                                            style={{
                                                                backgroundImage: `url(${thumbnail})`,
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="ml-4">
                                                        <div
                                                            className={
                                                                "d-flex text-dark-75 font-size-base mb-0 elipsis_3lines"
                                                            }
                                                            style={{
                                                                maxHeight: "52px",
                                                            }}
                                                        >
                                                            {title}
                                                            {visible === 0 ? (
                                                                <div
                                                                    className={
                                                                        "badge badge-info d-flex justify-content-center align-self-center"
                                                                    }
                                                                >
                                                                    <CustomTooltip
                                                                        config={{
                                                                            text: t(
                                                                                "ADMINPANEL.HOMEPAGE.BANNER.TABLE.TOOLTIP.INVISIBLE"
                                                                            ),
                                                                            placement: "top",
                                                                        }}
                                                                    >
                                                                        <VisibilityOff />
                                                                    </CustomTooltip>
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </div>
                                            </TableCell>
                                            {/* Column2: ORDER: */}
                                            <TableCell
                                                align="center"
                                                className="font-weight-bold text-dark-75 mb-0 font-size-1rem"
                                            >
                                                <div className="d-flex align-items-center justify-content-center">
                                                    {showEditOrder !== id ? (
                                                        <div className="min-w-20px">
                                                            {order || 0}
                                                            <CustomTooltip
                                                                config={{
                                                                    text: t(
                                                                        "ADMINPANEL.HOMEPAGE.BANNER.TOOLTIP.EDIT_ORDER"
                                                                    ),
                                                                    placement: "top",
                                                                }}
                                                            >
                                                                <button
                                                                    onClick={() => {
                                                                        setShowEditOrder(id);
                                                                    }}
                                                                    className="btn btn-icon btn-light ml-2 edit_button"
                                                                >
                                                                    <EditIcon />
                                                                </button>
                                                            </CustomTooltip>
                                                        </div>
                                                    ) : (
                                                        <input
                                                            type="number"
                                                            autoFocus
                                                            className={`form-control form-control-solid px-2 text-dark-75 font-weight-bolder font-size-base w-60px`}
                                                            defaultValue={order || 0}
                                                            onKeyDown={e => {
                                                                if (e.key === "Enter") {
                                                                    if (
                                                                        e.target.value &&
                                                                        Number(e.target.value) !== order
                                                                    )
                                                                        handleEditVideo(
                                                                            Number(e.target.value),
                                                                            "order",
                                                                            id
                                                                        );
                                                                }
                                                            }}
                                                            onBlur={e => {
                                                                if (e.target.value && Number(e.target.value) !== order)
                                                                    handleEditVideo(
                                                                        Number(e.target.value),
                                                                        "order",
                                                                        id
                                                                    );
                                                                else setShowEditOrder("");
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </TableCell>
                                            {/*Column3: ACTIONS: */}
                                            <TableCell align="center" className="m-auto">
                                                <CustomTooltip
                                                    config={{
                                                        text: t("ADMINPANEL.HOMEPAGE.BANNER.TABLE.TOOLTIP.DELETE"),
                                                        placement: "top",
                                                    }}
                                                >
                                                    <button
                                                        className="btn btn-icon btn-light btn-hover-primary btn-sm mr-2 button_blue_icon"
                                                        onClick={() => {
                                                            setVideoId(id);
                                                            setShowDeleteModal(true);
                                                        }}
                                                    >
                                                        <DeleteIcon />
                                                    </button>
                                                </CustomTooltip>
                                            </TableCell>
                                        </TableRow>
                                    )
                                )}

                        <TableRow style={{height: 48}}>
                            <TableCell colSpan={6} />
                        </TableRow>
                    </TableBody>

                    {/* pagination: */}
                    <TableFooter>
                        <TableRow>
                            <PaginationTable
                                setPage={setPage}
                                setRowsPerPage={setRowsPerPage}
                                rows={videos}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                rowsPerPageOptions={[5, 10, 25]}
                                variant={"filled"}
                            />
                        </TableRow>
                    </TableFooter>
                </Table>
            </div>

            {/* DELETE VIDEO confirmations: */}
            <ConfirmDelete
                show={showDeleteModal}
                onConfirm={deleteIt}
                onCancel={() => {
                    setShowDeleteModal(false);
                    setVideoId("");
                }}
            />
            <SuccessDelete
                show={showDeletedModal}
                onConfirm={() => {
                    setShowDeletedModal(false);
                }}
            />
            <FailedDelete
                show={showDeletedFailedModal}
                onConfirm={() => {
                    setShowDeletedFailedModal(false);
                }}
            />
        </div>
    );
};

TopBannerTable.propTypes = {
    videos: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default memo(TopBannerTable);
